/**
 * Register channel constants
 * Used for tracking user registration sources
 */
export const REGISTER_CHANNEL = {
  /** Google Ads source */
  GOOGLE_ADS: 1,
  /** Reddit Ads source */
  REDDIT_ADS: 2,
  /** Konst referral source */
  KONST: 3,
} as const

export type RegisterChannel = (typeof REGISTER_CHANNEL)[keyof typeof REGISTER_CHANNEL]
